var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlane(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#004169",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 95 95",
    enableBackground: "new 0 0 95 95",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M77.271,55.467L82,50.738c0.536-0.538-0.06-2.005-1.333-3.278c-1.273-1.273-2.741-1.87-3.278-1.333l-2.02,2.019    l-0.783-3.016l5.243-5.242c0.537-0.538-0.06-2.005-1.333-3.278s-2.74-1.87-3.278-1.333l-2.534,2.532l-0.999-3.845l9.056-9.057    c4.545-4.546,5.852-10.605,2.92-13.54c-2.933-2.932-8.994-1.626-13.539,2.921l-9.057,9.056l-3.844-0.999l2.533-2.532    c0.537-0.538-0.06-2.005-1.333-3.278c-1.274-1.273-2.74-1.87-3.278-1.333l-5.244,5.243l-3.015-0.784l2.02-2.019    c0.536-0.537-0.06-2.005-1.333-3.277c-1.273-1.273-2.743-1.871-3.279-1.336l-4.73,4.73c-0.457-0.117-7.004-1.731-9.361,2.545    l22.724,11.183L40.482,43.929l-0.089-0.088l-0.066,0.242l-1.889,1.89l-6.418-0.979c0,0-3.638-0.602-5.22,1.934l11.523,4.636    l-1.883,7.026l7.027-1.882l4.636,11.521c2.535-1.582,1.931-5.223,1.931-5.223l-0.976-6.417l1.889-1.887l0.244-0.064l-0.09-0.09    l12.443-12.442l11.183,22.723C79.002,62.472,77.389,55.926,77.271,55.467z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 29.568,
    y: 46.194,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 12.0873 116.413)",
    width: 1.171,
    height: 19.018
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 18.776,
    y: 63.149,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 -13.968 127.2065)",
    width: 1.171,
    height: 6.694
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 28.443,
    y: 48.399,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 2.9274 133.0973)",
    width: 1.171,
    height: 35.088
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 11.968,
    y: 79.069,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 -36.8467 149.5706)",
    width: 1.171,
    height: 6.694
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 29.759,
    y: 64.231,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -34.3322 46.755)",
    width: 19.018,
    height: 1.171
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 27.89,
    y: 72.262,
    transform: "matrix(-0.7063 -0.7079 0.7079 -0.7063 -4.9392 149.1704)",
    width: 1.173,
    height: 6.696
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 29.004,
    y: 47.294,
    transform: "matrix(-0.7059 -0.7084 0.7084 -0.7059 7.3947 124.7132)",
    width: 1.173,
    height: 27.054
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15.371,
    y: 71.108,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 -25.4085 138.3866)",
    width: 1.171,
    height: 6.696
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 33.562,
    y: 51.854,
    transform: "matrix(-0.7075 -0.7067 0.7067 -0.7075 12.1055 135.7699)",
    width: 1.172,
    height: 27.051
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 19.928,
    y: 75.665,
    transform: "matrix(-0.7077 -0.7065 0.7065 -0.7077 -20.7891 149.426)",
    width: 1.172,
    height: 6.696
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default __webpack_public_path__ + "static/media/plane.0e12e3cf90c208e8c0a4f030889e5b34.svg";
export { ForwardRef as ReactComponent };